/* eslint-disable prefer-destructuring */
import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';

import {
  Card,
  Switch,
  Grid,
  FormControlLabel,
  Divider,
} from '@material-ui/core';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import OpacityIcon from '@material-ui/icons/Opacity';
import AddAlert from '@material-ui/icons/AddAlert';
import CardTitle from 'src/components/sharedComponents/CardTitle';
import RightBar from 'src/components/polygons/Map/RightBar';
import DialogMap from 'src/components/polygons/Map/DialogMap';
import Map from 'src/components/polygons/Map/Map';
import { generalTitles } from 'src/constants';
import Snackbar from 'src/components/sharedComponents/Snackbar/Snackbar';

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    paddingRight: theme.spacing(2),
    background: 'white',
    minWidth: '100%',
  },
  justifyTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    padding: '2px',
    margin: '10px',
    paddingLeft: '2px',
    paddingRight: '2px',
    alignItems: 'center',
    [theme.breakpoints.down('xs')]: {
      justifyContent: 'space-around',
      margin: 'inherit',
    },
  },
}));

const MapaPage = (props) => {
  const {
    show,
    zonas,
    month,
    calculos,
    loading,
    permisos,
    colombia,
    estadistica,
    handleClose,
    onChangeZone,
    handleBigQuery,
    handleDeleteZona,
    handleSelectMonth,
    handleChangeColors,
  } = props;

  const classes = useStyles();

  return (
    <>
      <Snackbar
        place="tr"
        color="warning"
        icon={AddAlert}
        message="Actualización en progreso, espere un momento porfavor"
        open={loading} // true o false
      />
      <DialogMap
        show={show}
        zonas={zonas}
        handleClose={handleClose}
        onChangeZone={onChangeZone}
        handleDeleteZona={handleDeleteZona}
      />
      <CardTitle
        title={generalTitles.MAP_TITLE}
        subTitle={generalTitles.MAP_SUBTITLE}
      />
      <div style={{ margin: '10px' }}>
        <Card className={classes.justifyTitle}>
          <div>
            <OpacityIcon style={{ color: '#000', fontSize: '20px' }} />
            {' '}
            Mobility
            <OpacityIcon style={{ color: '#05305e', fontSize: '20px' }} />
            {' '}
            Auteco
            <OpacityIcon style={{ color: '#E67C7C', fontSize: '20px' }} />
            {' '}
            Honda
            <OpacityIcon style={{ color: '#B9B9B9', fontSize: '20px' }} />
            {' '}
            Yamaha
            <OpacityIcon style={{ color: '#83B37F', fontSize: '20px' }} />
            {' '}
            Hero
            <OpacityIcon style={{ color: '#026FCB', fontSize: '20px' }} />
            {' '}
            AKT
            <OpacityIcon style={{ color: '#B63429', fontSize: '20px' }} />
            {' '}
            UMA
            <OpacityIcon style={{ color: '#E6D97F', fontSize: '20px' }} />
            {' '}
            Suzuki
            <OpacityIcon style={{ color: '#8BF700', fontSize: '20px' }} />
            {' '}
            Otras
            <Divider orientation="vertical" flexItem />
          </div>
          <Divider orientation="vertical" flexItem />
          <FormControlLabel
            labelPlacement="start"
            label="Lider"
            control={(
              <Switch
                onChange={handleChangeColors}
                name="checkedB"
                color="primary"
              />
            )}
          />
        </Card>
        <br />
        <Grid container direction="row">
          <Grid item xs={12} sm={9} lg={9}>
            <Map loading={loading} />
          </Grid>
          <Grid item xs={12} sm={3} lg={3}>
            <Card>
              <FormControl variant="outlined" className={classes.formControl}>
                <InputLabel>Mes calculos</InputLabel>
                <Select
                  labelId="select-mes"
                  value={month}
                  fullWidth
                  onChange={handleSelectMonth}
                  label="Meses"
                >
                  <MenuItem value={1}>1 Mes</MenuItem>
                  <MenuItem value={3}>3 Meses</MenuItem>
                  <MenuItem value={6}>6 Meses</MenuItem>
                  <MenuItem value={12}>12 Meses</MenuItem>
                  <MenuItem value={18}>18 Meses</MenuItem>
                </Select>
              </FormControl>
            </Card>
            <br />
            <RightBar
              permisos={permisos}
              calculos={calculos}
              estadistica={estadistica}
              colombia={colombia}
              handleBigQuery={handleBigQuery}
            />
          </Grid>
        </Grid>
      </div>
    </>
  );
};

export default memo(MapaPage);
